import api from './api';

export interface Period {
  start: string;
  end: string;
}

export interface Absence {
  id: string;
  schoolId: string;
  lessonId: string;
  studentId: string;
  period: Period;
  recordedAt: string;
  recordedBy: string;
}

export interface AbsenceResponse extends Absence {
  studentName?: string;
  className?: string;
  courseName?: string;
  lessonTimeInfo?: string;
}

export interface BulkAbsenceRequest {
  lessonId: string;
  lessonDate: string; // YYYY-MM-DD
  studentIds: string[]; // List of IDs of students who are ABSENT
}

export interface AbsenceSearchRequest {
  startDate?: string;
  endDate?: string;
  classId?: string;
  lessonId?: string;
  studentId?: string;
  page?: number;
  size?: number;
}

export interface Page<T> {
  content: T[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
}

export const absenceService = {
  /**
   * Get all absences for a specific lesson and date
   */
  getAbsencesByLesson: async (lessonId: string, date: string): Promise<Absence[]> => {
    const response = await api.get<Absence[]>(`/{schoolId}/absences/lesson/${lessonId}?date=${date}`);
    return response.data;
  },

  /**
   * Search absences with filters (Paginated)
   */
  searchAbsences: async (request: AbsenceSearchRequest): Promise<Page<AbsenceResponse>> => {
    const response = await api.post<Page<AbsenceResponse>>(`/{schoolId}/absences/search`, request);
    return response.data;
  },

  /**
   * Delete an absence
   */
  deleteAbsence: async (absenceId: string): Promise<void> => {
    await api.delete(`/{schoolId}/absences/${absenceId}`);
  },

  /**
   * Bulk update attendance for a lesson
   * (Replaces existing absences for this lesson with the provided list)
   */
  bulkUpdateAbsences: async (request: BulkAbsenceRequest): Promise<void> => {
    await api.post(`/{schoolId}/absences/bulk`, request);
  }
};
